import React, { useEffect, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Select from 'react-select';
import Swal from 'sweetalert2';
import { generateAxiosInstance } from '../../hooks/useAuthorizedRequest';
import { generateAxiosInstanceSection } from '../../hooks/useAuthorizedRequestForSection';
import { generateAxiosInstanceInstitute } from '../../hooks/useAuthorizedRequestForInstitute';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../../components/ModalsCommonFunctions';
import { deleteItem, findPageNumber, searchArray, SortIcon } from '../../components/Navigation';
import Pagination from '../../components/Pagination';

const TeacherMapping = () => {
    const authorizedAxios = generateAxiosInstance()
    const authorizedAxiosSection = generateAxiosInstanceSection()
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute()
    let instituteMasterId = localStorage.getItem("instituteMasterId")
    let sectionMasterId = localStorage.getItem("sectionMasterId")

    const initialFormState = {
        academicYearMasterId: "",
        teacherMasterId: "",
        instituteGradeMasterId: '',
        instituteDivisionMasterId: '',
        instituteSubjectMasterId: []
    }

    const [refreshList, setRefreshList] = useState(false)
    const [academicYearList, setAcademicYearList] = useState([])
    const [teacherList, setTeacherList] = useState([])
    const [subjectList, setSubjectList] = useState([])
    const [GradeList, setGradeList] = useState([])
    const [DivisionList, setDivisionList] = useState([])
    const [selectSubjectList, setSelectSubjectList] = useState([])
    const [TeacherMappingData, setTeacherMappingData] = useState(initialFormState)
    const [teacherMapptingList, setTeacherMapptingList] = useState([])
    const [editId, setEditId] = useState(null)

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);

    const [subjectNameSort, setSubjectNameSort] = useState(null)

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["academicYearMasterDetails.yearName", "teacherMasterDetails.teacherName", "instituteGradeMasterDetails.gradeName", "instituteDivisionMasterDetails.divisionName", "instituteSubjectMasterDetails.subjectName"];


    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getYearList();
        getTeacherList();
        getGradeList()
        getSubjectList()
    }, []);

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            getTeacherMappingList();
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            setTeacherMapptingList(await searchArray("B", getApiUrl(), searchKeys, searchValue.trim()))
        }
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(teacherMapptingList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId])

    useEffect(() => {
        setTotalPages(Math.ceil(teacherMapptingList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > teacherMapptingList.length) {
            endIndex = teacherMapptingList.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(teacherMapptingList.slice(startIndex, endIndex));
    }, [teacherMapptingList, currPage, itemsPerPage]);

    const getApiUrl = () => {
        let apiUrl = '/get-teacher-mapping?';

        if(TeacherMappingData.academicYearMasterId !== '') {
            apiUrl += `academicYearMasterId=${TeacherMappingData.academicYearMasterId}&`
        }

        if (TeacherMappingData.teacherMasterId !== '') {
            apiUrl += `teacherMasterId=${TeacherMappingData.teacherMasterId}&`;
        }

        if (TeacherMappingData.instituteGradeMasterId !== '') {
            apiUrl += `instituteGradeMasterId=${TeacherMappingData.instituteGradeMasterId}&`;
        }
        if (TeacherMappingData.instituteDivisionMasterId !== '') {
            apiUrl += `instituteDivisionMasterId=${TeacherMappingData.instituteDivisionMasterId}&`;
        }
        if (TeacherMappingData.instituteSubjectMasterId.length !== 0) {
            apiUrl += `instituteSubjectMasterId=${TeacherMappingData.instituteSubjectMasterId}&`;
        }

        apiUrl = apiUrl.replace(/&$/, '');
        return apiUrl;
    }

    useEffect(() => {
        getTeacherMappingList();
    }, [TeacherMappingData.teacherMasterId, TeacherMappingData.academicYearMasterId, TeacherMappingData.instituteGradeMasterId, TeacherMappingData.instituteDivisionMasterId, TeacherMappingData.instituteSubjectMasterId]);

    const getTeacherMappingList = async () => {
        if (TeacherMappingData.teacherMasterId !== '') {
            try {
                const response = await authorizedAxiosSection.get(getApiUrl());
                setTeacherMapptingList(response.data.result);
            } catch (error) {
                setTeacherMapptingList([]);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            }
        }
    }

    const getYearList = () => {
        const apiUrlForSyllabus = `/active-academic-years`;
        authorizedAxios && authorizedAxios.get(apiUrlForSyllabus)
            .then(response => {
                setAcademicYearList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const getTeacherList = () => {
        const apiUrlForSyllabus = `/get-teacher?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrlForSyllabus)
            .then(response => {
                setTeacherList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const getGradeList = () => {
        const apiUrlForSyllabus = `/get-institute-grade?instituteMasterId=${instituteMasterId}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrlForSyllabus)
            .then(response => {
                setGradeList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const getSubjectList = () => {
        const apiUrlForSyllabus = `/get-institute-subjects?instituteMasterId=${instituteMasterId}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrlForSyllabus)
            .then(response => {
                setSubjectList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleInputChange = (e) => {
        setTeacherMappingData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value
            }
        })
    }

    const handleGradeChange = (e) => {
        setTeacherMappingData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                instituteDivisionMasterId: ""
            }
        })
        const apiUrlForSyllabus = `/grade-wise-division?instituteMasterId=${instituteMasterId}&instituteGradeMasterId=${e.target.value}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrlForSyllabus)
            .then(response => {
                setDivisionList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleEditGradeChange = (id) => {
        const apiUrlForSyllabus = `/grade-wise-division?instituteMasterId=${instituteMasterId}&instituteGradeMasterId=${id}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrlForSyllabus)
            .then(response => {
                setDivisionList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    useEffect(() => {
        if (editId !== null && editId !== "" && TeacherMappingData.instituteGradeMasterId !== "") {
            handleEditGradeChange(TeacherMappingData.instituteGradeMasterId); // Call handleEditGradeChange when editId changes
        }
    }, [editId]);

    const selectedSubjectLabel = selectSubjectList.find(subject => subject.value == TeacherMappingData.instituteSubjectMasterId)?.label;

    const handleChangeSubjcet = (selectedOptions) => {
        const selectedIds = selectedOptions.map((option) => option.value.toString());
        setTeacherMappingData((prevData) => {
            return {
                ...prevData,
                instituteSubjectMasterId: selectedIds,
            }
        })
    }

    useEffect(() => {
        setSelectSubjectList(subjectList.map((i) => {
            return {
                value: i.id,
                label: i.subjectName
            }
        }))
    }, [subjectList])

    //error
    const initialErrorState = {

    }
    const [error, setError] = useState(initialErrorState)
    const validateForm = () => {
        return Object.values(error).every((error) => error === '') && Object.values(TeacherMappingData).every((value) => typeof (value) == "string" ? value !== '' : value.length !== 0)
    };

    useEffect(() => {
        if (!Object.values(error).every((error) => error === '')) {
            for (const [key, value] of Object.entries(TeacherMappingData)) {
                if (value === '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }, [TeacherMappingData])

    const addTeacherMapping = async () => {
        if (validateForm()) {
            try {
                setLoading(true);
                const apiUrl = `/add-teacher-mapping`;
                const response = await authorizedAxiosSection.post(apiUrl, TeacherMappingData)
                setTeacherMappingData((prevData) => {
                    return {
                        ...prevData,
                        instituteSubjectMasterId: [],
                    }
                })
                await getTeacherMappingList();
                setSaveId(response.data.result[0].id);
                setSubjectNameSort(null);
                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        } else {
            for (const [key, value] of Object.entries(TeacherMappingData)) {
                if (value === '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }

    const deleteMapping = async (id) => {
        let confirmed = window.confirm('Are you sure? you want to delete this record.');
        if (confirmed) {
            try {
                setLoading(true);
                const apiUrl = `/delete-teacher-mapping?teacherMappingId=${id}`;
                const response = await authorizedAxiosSection.delete(apiUrl);
                const page = deleteItem(currPage, itemsPerPage, teacherMapptingList.length);
                await getTeacherMappingList();
                setCurrPage(page);
                Swal.fire({ text: response.data.message });
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        }
    }

    const updateTeacherMapping = async () => {
        if (validateForm()) {
            try {
                setLoading(true);
                let updateData = {
                    teacherMasterId: TeacherMappingData.teacherMasterId,
                    instituteGradeMasterId: TeacherMappingData.instituteGradeMasterId,
                    instituteDivisionMasterId: TeacherMappingData.instituteDivisionMasterId,
                    teacherMappingId: editId
                }
                const apiUrl = `/edit-teacher-mapping`;
                const response = await authorizedAxiosSection.put(apiUrl, updateData)
                await getTeacherMappingList();
                setEditId(null);
                setError(initialErrorState);
                setSubjectNameSort(null);

                setTeacherMappingData({
                    ...initialFormState,
                    teacherMasterId: TeacherMappingData.teacherMasterId
                })
                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        } else {
            for (const [key, value] of Object.entries(TeacherMappingData)) {
                if (value === '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }

    const changeActive = (id) => {
        setLoading(true);
        const apiUrl = `/teacher-map-active?teacherMappingId=${id}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrl)
            .then(response => {
                // setRefreshList(!refreshList)
                getTeacherMappingList();
                setTimeout(() => {
                    Swal.fire({ text: response.data.message });
                }, 100);
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            })
            .finally(() => {
                setLoading(false); // End loading
            });
    }

    const handleInputReset = () => {
        setTeacherMapptingList([]);
        setEditId('');
        setError(initialErrorState);
        setTeacherMappingData(initialFormState);
    }

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <div id='scroll-up'></div>
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb my-0 ms-2">
                        <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/section-dashboard')}>
                            <span>Dashboard</span>
                        </li>
                        <li className="breadcrumb-item active"><span>Teacher Mapping</span></li>
                    </ol>
                </nav>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-arrow-right-arrow-left"></i> Teacher Mapping</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Teacher :</label>
                                                    <select class="form-select" aria-label="Default select example" disabled={editId} name='teacherMasterId' onChange={handleInputChange} value={TeacherMappingData.teacherMasterId}>
                                                        <option selected value={''} disabled>Select Teacher</option>
                                                        {
                                                            teacherList?.map((teacher) => {
                                                                return <option value={teacher.id}>{teacher.teacherName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.teacherMasterId && <p style={{ color: 'red' }}>{error.teacherMasterId}</p>}

                                                </div>

                                                <div className="col-md-6">
                                                    <label for="academicYearMasterId" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Academic Year :</label>
                                                    <select class="form-select" aria-label="Default select example" name='academicYearMasterId' onChange={handleInputChange} value={TeacherMappingData.academicYearMasterId}>
                                                        <option selected value={''} disabled>Select Year</option>
                                                        {
                                                            academicYearList?.map((year) => {
                                                                return <option value={year.id}>{year.yearName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.academicYearMasterId && <p style={{ color: 'red' }}>{error.academicYearMasterId}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Class :</label>
                                                    <select class="form-select" aria-label="Default select example" name='instituteGradeMasterId' onChange={handleGradeChange} value={TeacherMappingData.instituteGradeMasterId}>
                                                        <option selected value={''} disabled>Select Class</option>
                                                        {
                                                            GradeList?.map((grade) => {
                                                                return <option value={grade.id}>{grade.gradeName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.instituteGradeMasterId && <p style={{ color: 'red' }}>{error.instituteGradeMasterId}</p>}

                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Division :</label>
                                                    <select class="form-select" aria-label="Default select example" name='instituteDivisionMasterId' onChange={handleInputChange} value={TeacherMappingData.instituteDivisionMasterId}>
                                                        <option selected value={''} disabled>Select Division</option>
                                                        {
                                                            DivisionList?.map((division) => {
                                                                return <option value={division.id}>{division.divisionName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.instituteDivisionMasterId && <p style={{ color: 'red' }}>{error.instituteDivisionMasterId}</p>}

                                                </div>

                                                {editId ? <div className="col-md-6">
                                                    <label for="instituteSubjectMasterId" className="col-form-label"><span style={{ color: "red" }}>*</span>Selected Subject :</label>
                                                    <input type="text" disabled={editId} className="form-control" name="instituteSubjectMasterId" value={selectedSubjectLabel || ''} onChange={handleChangeSubjcet} />
                                                    {error.instituteSubjectMasterId && <p style={{ color: 'red' }}>{error.instituteSubjectMasterId}</p>}
                                                </div>
                                                    :
                                                    <div className="col-md-6">
                                                        <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject :</label>

                                                        <Select
                                                            value={selectSubjectList.filter(option =>
                                                                TeacherMappingData.instituteSubjectMasterId && TeacherMappingData.instituteSubjectMasterId.includes(option.value.toString())
                                                            )}
                                                            isMulti
                                                            name="instituteSubjectMasterId"
                                                            options={selectSubjectList}
                                                            className="basic-multi-select"
                                                            classNamePrefix="Select Medium"
                                                            onChange={handleChangeSubjcet}
                                                        />

                                                        {error.instituteSubjectMasterId && <p style={{ color: 'red' }}>{error.instituteSubjectMasterId}</p>}


                                                    </div>}
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12 mt-3 d-flex justify-content-center button-container">
                                                    {
                                                        !editId && <button className="btn btn-primary" type="button" onClick={addTeacherMapping}>Save</button>
                                                    }
                                                    <button className="btn btn-outline-danger delete_icon" type="button" onClick={handleInputReset}>Reset</button>
                                                    {
                                                        editId && (<button className="btn btn-success approve_icon" type="button" onClick={updateTeacherMapping} disabled={!editId}>Update</button>)
                                                    }
                                                </div>

                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope="col">Academic Year</th>
                                                                        <th scope="col">Teacher Name</th>
                                                                        <th scope="col">Class Name</th>
                                                                        <th scope="col">Division Name</th>
                                                                        <th scope="col">
                                                                            Subject Name
                                                                            <SortIcon sortState={subjectNameSort} setSortState={setSubjectNameSort} setData={setTeacherMapptingList} setCurrPage={setCurrPage} sortingPath={"instituteSubjectMasterDetails.subjectName"} />
                                                                        </th>
                                                                        <th scope="col">Active/Inactive</th>
                                                                        <th scope="col">Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData?.length > 0 ?
                                                                            displayedData?.map((lesson, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                        <td>{lesson.academicYearMasterDetails?.yearName}</td>
                                                                                        <td>{lesson.teacherMasterDetails?.teacherName}</td>
                                                                                        <td>{lesson.instituteGradeMasterDetails.gradeName}</td>
                                                                                        <td>{lesson.instituteDivisionMasterDetails?.divisionName}</td>
                                                                                        <td>{lesson.instituteSubjectMasterDetails.subjectName}</td>
                                                                                        <td>
                                                                                            <div className={`toggle-container ${lesson.isActive ? 'active' : ''}`} onClick={() => changeActive(lesson.id)}>
                                                                                                <div className="toggle-background"></div>
                                                                                                <div className="toggle-switch"></div>
                                                                                            </div>
                                                                                        </td>
                                                                                        <td>
                                                                                            <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => {
                                                                                                setTeacherMappingData({
                                                                                                    teacherMasterId: lesson?.teacherMasterId,
                                                                                                    instituteGradeMasterId: lesson?.instituteGradeMasterId,
                                                                                                    instituteDivisionMasterId: lesson?.instituteDivisionMasterId,
                                                                                                    instituteSubjectMasterId: lesson?.instituteSubjectMasterId
                                                                                                });
                                                                                                setEditId(lesson.id);
                                                                                                document.getElementById('scroll-up').scrollIntoView({ behavior: 'smooth' });
                                                                                            }}><i class="fa-light fa-pen-to-square"></i></button>
                                                                                            <button className="btn btn-outline-danger delete_icon" disabled={editId === lesson.id} type="button" onClick={() => deleteMapping(lesson.id)}> <i class="fa-light fa-trash-can"></i></button>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Teacher Available</th>

                                                                            </tr>)
                                                                    }

                                                                </tbody>
                                                            </table>
                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={teacherMapptingList.length} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default TeacherMapping;